/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkMatchItem } from './bulkMatchItem';

export interface BulkMatchResponse {
  results: BulkMatchItem[];
  matched_count: number;
  unmatched_count: number;
}
